"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWWWDomain = exports.isLocalDomain = void 0;
const LOCAL_DOMAIN_REGEX = /localhost/;
const isLocalDomain = () => LOCAL_DOMAIN_REGEX.test(location.host);
exports.isLocalDomain = isLocalDomain;
const isWWWDomain = () => {
    return /www/.test(window.location.host);
};
exports.isWWWDomain = isWWWDomain;
//# sourceMappingURL=domain.utility.js.map